import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { useRouter } from '@tanstack/react-router';

/** A real anchor whose internal hrefs route client-side. The DS renders its links with this. */
export function RouterAnchor({
  href,
  onClick,
  target,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const router = useRouter();
  const internal = !!href && href.startsWith('/') && !href.startsWith('//');

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (!internal || event.defaultPrevented || target || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    void router.navigate({ href });
  };

  return <a {...rest} href={href} target={target} onClick={handleClick} />;
}
